import React from "react"
import { graphql, Link } from "gatsby"

/*import {
  parseISO,
  format
} from 'date-fns'*/
import { ChevronLeft } from "react-feather"

import Layout from "../layouts/default"
//import Seo from "../utils/seo"
import HtmlHead from "../utils/head"
import Pill from "@ui-kit/atoms/button/pill"

import PageLayout from "../components/display/page"
import Prose from "@ui-kit/atoms/prose"

import Promotion from "../components/promotion"
//import Breadcrumb from '../components/breadcrumb'

//const striptags = require("striptags")

const Scene = ({
  data: {
    wysiwygHTMLVideos: { nodes: wysiwygHTMLVideos },
    wysiwygVideos: { nodes: wysiwygVideos },
    node,
  },
  pageContext: { wysiwygFiles, wysiwygImages, isBusinessPage },
}) => {
  const {
    relationships: { promotions },
  } = node

  //const date = node.changedOverride || node.changed;

  return node ? (
    <Layout isBusinessPage={isBusinessPage}>

      <PageLayout>
        <aside>
          {node.relationships.category && node.relationships.category.path ? (
            <Link to={`${node.relationships.category.path.alias}`}>
              <Pill inverted elem={"span"}>
                <ChevronLeft />
                <span className="truncate">
                  More {node.relationships.category.name}
                </span>
              </Pill>
            </Link>
          ) : (
            <Link to={"/help-advice"}>
              <Pill inverted elem={"span"}>
                <ChevronLeft />
                Help &amp; Advice
              </Pill>
            </Link>
          )}

          {/*}
              <Breadcrumb links={[
                {
                  label: 'Help & advice',
                  link: 'help-advice'
                }, {
                  label: node.relationships.category.name,
                  link: node.relationships.category.path.alias
                }, {
                  label: node.title,
                  link: node.path.alias
                }
              ]} />*/}
        </aside>
        {node.body && (
          <article itemScope itemType="http://schema.org/NewsArticle">
            <h1 itemProp="headline">{node.title}</h1>
            <Prose
              env={process.env.GATSBY_SITE}
              className="prose"
              itemProp={"articleBody"}
              html={node.body.html}
              wysiwygFiles={wysiwygFiles}
              wysiwygImages={wysiwygImages}
              wysiwygVideos={wysiwygVideos}
              wysiwygHTMLVideos={wysiwygHTMLVideos}
            />

            {promotions.map((promotion, i) => (
              <Promotion key={i} {...promotion} />
            ))}
          </article>
        )}
      </PageLayout>
    </Layout>
  ) : null
}

export function Head({ data: { node }, ...props }) {
  node.metatags = JSON.stringify(node.metatags);
  const page = {
    ...node,
    ...node.metatags_other,
  }

  return <HtmlHead {...page} />
}

export default Scene

export const query = graphql`
  query KnowledgeBase($nid: Int!) {
    wysiwygVideos: allMediaVideo {
      nodes {
        id: drupal_id
        name: field_title
        url: field_media_video_embed_field
      }
    }
    wysiwygHTMLVideos: allMediaHtml5Video {
      nodes {
        id: drupal_id
        r: relationships {
          video: field_media_video_file {
            file: localFile {
              publicURL
            }
          }
          poster: field_poster {
            r: relationships {
              image: field_media_image {
                file: localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
    node: nodeKnowledgeBaseItem(drupal_internal__nid: { eq: $nid }) {
      nid: drupal_internal__nid
      title
      path {
        alias
      }
      metatags:field_metatag {
        title
      }
      body: field_response {
        html: value
      }
      changedOverride: field_last_updated
      changed
      relationships {
        category: field_category {
          name
          path {
            alias
          }
        }
        promotions: field_promotions {
          type: __typename
          ... on paragraph__outage_map {
            relationships {
              block: field_outage_block {
                info
              }
            }
          }
        }
      }
    }
  }
`
